import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";

import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";
import useDEAClassList from "./hooks/useDeaClassList";

const DeaClassList = ({
  onSelect,
  hideModal,
  params,
  lookupType,
  selectModeParamData = null,
}) => {
  const deaClassListData = useDEAClassList(
    onSelect,
    hideModal,
    params,
    lookupType,
    selectModeParamData
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={deaClassListData.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {deaClassListData.screen_title} -{" "}
          <span className="heading-cod">{deaClassListData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={deaClassListData.formFields}
        dropdownValues={deaClassListData.dropdownValues}
        paramsData={deaClassListData.paramsData}
        updataParamData={deaClassListData.updateParamData}
      />
      <ButtonsSection ctaButtons={deaClassListData.ctaButtons} />
      <DisplayTable
        data={deaClassListData.data}
        parmKey={deaClassListData.parmKey}
        menuOptions={deaClassListData.menuOptions}
        tableHeaders={deaClassListData.columnDef}
        setRowData={deaClassListData.setRowData}
        selectedPriceSchedules={deaClassListData.selectedRows}
        setSelectedPriceSchedules={deaClassListData.setSelectedRows}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={deaClassListData.first}
          rows={deaClassListData.rows}
          totalRecords={deaClassListData.totalRecords}
          currentPage={deaClassListData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={deaClassListData.onPageChange}
        />
      </div>
      {deaClassListData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={deaClassListData.isConfirmationModalOpen}
          onRequestClose={deaClassListData.closeConfirmationModal}
          onBack={deaClassListData.closeConfirmationModal}
          onSave={deaClassListData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={deaClassListData.setSelectedOption}
        />
      )}
      {deaClassListData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={deaClassListData.isHideConfirmationModalOpen}
          onRequestClose={deaClassListData.closeHideConfirmationModal}
          onBack={deaClassListData.closeHideConfirmationModal}
          onSave={deaClassListData.hidePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={deaClassListData.setHideSelectedOption}
        />
      )}
    </div>
  );
};

export default DeaClassList;
